<template>
  <div id="test-intro">
    <comp-header
      :headerPosition="headerPos"
      :leftIcon="headerLeftIcon"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious"
    />
    <div class="qr-wrapper">
      <div class="qr-container">
        <p class="qr-txt" v-html="qrMessage"></p>
        <img :src="qrImg" alt="" />
        <p class="qr-txt" v-html="$t('match.qr.message2')"></p>
      </div>
    </div>
    <div class="fixed-bottom">
      <form-button
        :btnName="buttonName"
        isActive
        @click.native="goPage('/match/qr-scan')"
      ></form-button>
    </div>
    <comp-loading v-if="isLoading"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import RESPONSE from '@/constants/response';
import CompHeader from '@/components/CompHeader';
import FormButton from '@/components/FormButton';
import CompLoading from '@/components/CompLoading';

export default {
  name: 'test-intro',
  mixins: [common],
  data() {
    return {
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('match.qr.header'),
      buttonName: this.$i18n.t('match.qr.button'),
      qrImg: null,
      qrMessage: this.$i18n.t('match.qr.message1'),
      isLoading: false,
    };
  },
  components: {
    RESPONSE,
    CompHeader,
    FormButton,
    CompLoading,
  },
  methods: {
    getQRCode() {
      this.isLoading = true;

      this.$store.dispatch('getQRCode').then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.getQRCode();
            } else {
              this.invalidateLogin();
            }
          });
        } else if (Object.prototype.hasOwnProperty.call(data, 'data')) {
          this.qrImg = `data:image/jpg;base64,${data.data.data}`;
        }
        this.isLoading = false;
      });
    },
    getGroupQRCode(groupId) {
      this.isLoading = true;

      this.$store.dispatch('getGroupQRCode', { groupId }).then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.getQRCode();
            } else {
              this.invalidateLogin();
            }
          });
        } else if (Object.prototype.hasOwnProperty.call(data, 'data')) {
          this.qrImg = `data:image/jpg;base64,${data.data.data}`;
        }
        this.isLoading = false;
      });
    },
  },
  created() {
    if (this.$route.params.exec) {
      this.goPage('/match/qr-scan');
    } else if (this.$route.params.type) {
      const qrType = this.$route.params.type;
      if (qrType === 'groupQr') {
        this.headerPageTitle = this.$i18n.t('friends.groupQr');
        this.qrMessage = this.$i18n.t('match.qr.message3');
        this.getGroupQRCode(this.$route.params.groupId);
      } else if (qrType === 'groupScan') {
        this.$router.push({
          name: 'match-qr-scan',
          params: {
            groupId: this.$route.params.groupId,
          },
        });
      }
    } else {
      this.getQRCode();
    }
  },
};
</script>

<style lang="scss" src="../../scss/match-qr.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/match/match-qr.vue